<template>
  <section class="menu computer">
    <div class="logo">
      <router-link to="/" :aria-label="$t('menu.alt.home')">
        <img src="@/assets/images/logo.svg" :alt="$t('menu.alt.logo')" />
      </router-link>
    </div>

    <div class="navigation">
      <div class="top-nav">
        <ul>
          <li>
            <router-link
              to="/naucne-videa"
              :aria-label="$t('menu.naucneVidea')"
            >
              <div class="icon">
                <img
                  src="@/assets/images/icons/naucneVidea.svg"
                  :alt="$t('menu.alt.lessons')"
                />
              </div>
              {{ $t("menu.naucneVidea") }}
            </router-link>
          </li>

          <li>
            <router-link
              to="/ciselne-zapisy"
              :aria-label="$t('menu.ciselneZapisy')"
            >
              <div class="icon">
                <img
                  src="@/assets/images/icons/ciselneZapisy.svg"
                  :alt="$t('menu.alt.scores')"
                />
              </div>
              {{ $t("menu.ciselneZapisy") }}
            </router-link>
          </li>

          <li>
            <router-link to="/spevnik" :aria-label="$t('menu.textyPiesni')">
              <div class="icon">
                <img
                  src="@/assets/images/icons/textyPiesni.svg"
                  :alt="$t('menu.alt.lyrics')"
                />
              </div>
              {{ $t("menu.textyPiesni") }}
            </router-link>
          </li>

          <li>
            <router-link to="/helifest" :aria-label="$t('menu.helifest')">
              <div class="icon">
                <img
                  src="@/assets/images/icons/helifest.svg"
                  :alt="$t('menu.alt.festival')"
                />
              </div>
              {{ $t("menu.helifest") }}
            </router-link>
          </li>

          <li>
            <router-link to="/helishop" :aria-label="$t('menu.helishop')">
              <div class="icon">
                <img
                  src="@/assets/images/icons/merch.svg"
                  :alt="$t('menu.alt.shop')"
                />
              </div>
              {{ $t("menu.helishop") }}
            </router-link>
          </li>

          <li>
            <router-link to="/o-nas" :aria-label="$t('menu.oNas')">
              <div class="icon">
                <img
                  src="@/assets/images/icons/oNas.svg"
                  :alt="$t('menu.alt.about')"
                />
              </div>
              {{ $t("menu.oNas") }}
            </router-link>
          </li>
        </ul>
      </div>

      <div class="bot-nav">
        <ul>
          <li>
            <router-link to="/kosik" :aria-label="$t('menu.kosik')">
              <div class="icon">
                <img
                  src="@/assets/images/icons/kosik.svg"
                  :alt="$t('menu.alt.cart')"
                />
              </div>
              {{ $t("menu.kosik") }}
            </router-link>

            <p
              v-if="Object.keys(this.$store.state.userCart).length != 0"
              class="cart-number"
            >
              {{ getTotalCartItem() }}
            </p>
          </li>

          <li>
            <router-link to="/pomoc" :aria-label="$t('menu.pomoc')">
              <div class="icon">
                <img
                  src="@/assets/images/icons/pomoc.svg"
                  :alt="$t('menu.alt.help')"
                />
              </div>
              {{ $t("menu.pomoc") }}
            </router-link>
          </li>

          <!-- ZOZNAM PIESNÍ -->
          <router-link
            v-if="$store.state.user != null"
            to="/ucebna/moje-piesne"
            class="login button prihlaseny menu-link-with-badge"
            @click="markSongsSeen"
            :aria-label="$t('menu.zoznamPiesni')"
          >
            <img
              src="@/assets/images/icons/zoznam.svg"
              :alt="$t('menu.alt.songList')"
            />
            <router-link to="/ucebna/moje-piesne">
              {{ $t("menu.zoznamPiesni") }}
            </router-link>

            <span v-if="hasNewSongsBadge" class="ha-new-badge">
              {{ $t("menu.badgeNew") }}
            </span>
          </router-link>

          <!-- ONLINE VÝUČBA -->
          <router-link
            v-if="$store.state.user != null"
            to="/ucebna/moje-kurzy"
            class="login button prihlaseny"
            :class="$store.state.user.isSubscribed ? 'green' : ''"
            :aria-label="$t('menu.onlineVyucba')"
          >
            <img
              src="@/assets/images/icons/online.svg"
              :alt="$t('menu.alt.onlineLessons')"
            />
            <router-link to="/ucebna/moje-kurzy">
              {{ $t("menu.onlineVyucba") }}
            </router-link>
          </router-link>
        </ul>
      </div>

      <router-link
        v-if="$store.state.user == null"
        to="/prihlasenie"
        class="login button"
        :aria-label="$t('menu.prihlasitSa')"
      >
        <img
          @click="this.odhlasenie()"
          src="@/assets/images/icons/prihlasenie.svg"
          :alt="$t('menu.alt.login')"
        />
        <router-link to="/prihlasenie">
          {{ $t("menu.prihlasitSa") }}
        </router-link>
      </router-link>

      <div class="moj-ucet">
        <router-link
          v-if="$store.state.user != null"
          to="/ucebna"
          class="login no-padding button"
          :aria-label="$t('menu.mojaUcebna')"
        >
          <img
            :src="profilePhoto"
            :alt="$t('menu.alt.profilePhoto')"
            class="profile-icon"
          />
          <p>{{ $t("menu.mojaUcebna") }}</p>
          <a class="logout">
            <img
              @click="this.odhlasenie()"
              src="@/assets/images/icons/odhlasenie.svg"
              :alt="$t('menu.alt.logout')"
            />
          </a>
        </router-link>
      </div>
    </div>
  </section>
</template>

<script>
import defaultAvatar from "@/assets/images/icons/prihlasenie.svg";

export default {
  data() {
    return {
      hasNewSongsBadge: false,
      unregAfterEach: null, // (bez podčiarkovníka) odregistrujeme router hook pri unmount
    };
  },

  computed: {
    profilePhotoRaw() {
      return this.$store.state.user?.profilePhotoUrl || "";
    },
    profilePhoto() {
      if (!this.profilePhotoRaw) return defaultAvatar;
      return this.stripWWW(this.profilePhotoRaw);
    },
    userKey() {
      const u = this.$store.state.user;
      if (!u) return "guest";
      return (
        (u.id != null && String(u.id)) ||
        (u.email && String(u.email).toLowerCase()) ||
        "guest"
      );
    },
  },

  mounted() {
    this.safeEvaluateBadge();

    // auto-zhasnutie po vstupe do /ucebna/moje-piesne
    if (this.$router?.afterEach) {
      this.unregAfterEach = this.$router.afterEach((to) => {
        if (to?.path?.startsWith?.("/ucebna/moje-piesne")) {
          this.markSongsSeen();
        }
      });
    }
  },

  beforeUnmount() {
    if (this.unregAfterEach) {
      try {
        this.unregAfterEach();
      } catch (e) {
        /* no-op */
      }
    }
  },

  watch: {
    "$store.state.user"() {
      this.safeEvaluateBadge();
    },
    "$store.state.user.ownedNotes.length"() {
      this.safeEvaluateBadge();
    },
  },

  methods: {
    stripWWW(url) {
      if (!url) return url;
      try {
        const u = new URL(url);
        if (u.hostname.startsWith("www.")) u.hostname = u.hostname.slice(4);
        return u.toString();
      } catch (e) {
        return url.replace(/^https?:\/\/www\./, (m) => m.replace("www.", ""));
      }
    },

    odhlasenie() {
      this.$store.dispatch("odhlasenie");
    },

    getTotalCartItem() {
      return this.$store.state.userCart.reduce(
        (sum, item) => sum + item.count,
        0
      );
    },

    // ———— logika „Nové“ ————
    getOwnedCount() {
      const list = this.$store.state.user?.ownedNotes || [];
      return Array.isArray(list) ? list.length : 0;
    },
    isSongsRoute() {
      return this.$route?.path?.startsWith?.("/ucebna/moje-piesne");
    },
    hasLastSeen() {
      try {
        return (
          localStorage.getItem(`ha_songs_last_seen_${this.userKey}`) !== null
        );
      } catch (e) {
        return false;
      }
    },
    readLastSeen() {
      try {
        const parsed = Number(
          localStorage.getItem(`ha_songs_last_seen_${this.userKey}`) || "0"
        );
        return Number.isFinite(parsed) && parsed >= 0 ? parsed : 0;
      } catch (e) {
        /* no-op */ return 0;
      }
    },
    writeLastSeen(count) {
      try {
        localStorage.setItem(
          `ha_songs_last_seen_${this.userKey}`,
          String(count)
        );
      } catch (e) {
        /* no-op */
      }
    },
    setAlert(on) {
      this.hasNewSongsBadge = !!on;
      try {
        localStorage.setItem(`ha_songs_alert_${this.userKey}`, on ? "1" : "0");
      } catch (e) {
        /* no-op */
      }
    },
    async fetchOwnedCountFromServer() {
      try {
        const res = await fetch(
          this.$store.state.api + "/product/getOwned.php",
          {
            credentials: "include",
          }
        );
        const json = await res.json().catch(() => null);
        if (
          json?.status === "Request succesfull" &&
          Array.isArray(json?.data)
        ) {
          return json.data.length;
        }
      } catch (e) {
        /* no-op */
      }
      return this.getOwnedCount();
    },

    evaluateBadge() {
      if (!this.$store.state.user) {
        this.setAlert(false);
        return;
      }

      const current = this.getOwnedCount();
      const hasStoredBaseline = this.hasLastSeen();
      const lastSeen = this.readLastSeen();

      if (this.isSongsRoute()) {
        if (current > 0 || !hasStoredBaseline) {
          this.writeLastSeen(current);
        }
        this.setAlert(false);
        return;
      }

      if (!hasStoredBaseline) {
        this.writeLastSeen(current);
        this.setAlert(false);
        return;
      }
      this.setAlert(current > lastSeen);
    },

    safeEvaluateBadge() {
      this.evaluateBadge();

      if (this.$store.state.user && this.getOwnedCount() === 0) {
        setTimeout(() => this.evaluateBadge(), 300);
        setTimeout(() => this.evaluateBadge(), 900);
      }
    },

    // klik / vstup do „moje-piesne“
    async markSongsSeen() {
      if (!this.$store.state.user) return;

      let current = this.getOwnedCount();
      if (current === 0) {
        current = await this.fetchOwnedCountFromServer();
      }

      this.writeLastSeen(current);
      this.setAlert(false);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/sass/_colors.scss";

.button.login.no-padding {
  padding: 0;
}

.profile-icon {
  border-top-left-radius: 50% !important;
  border-top-right-radius: 50% !important;
  border-bottom-left-radius: 50% !important;
  border-bottom-right-radius: 50% !important;
  width: 1.5em !important;
  height: 1.5em !important;
  padding: 0.5em !important;
  margin-right: 0 !important;
  object-fit: cover;
  filter: drop-shadow(3px 3px 3px rgba(0, 0, 0, 0.3));
}

.menu {
  height: 100%;
  width: 27vw;
  max-width: 20em;
  min-width: 17em;
  --menu-icon-size: 1em;
  --menu-login-icon-size: 1.4em;
  --menu-li-size: 1.5625em;
  --menu-li-width: 13.5rem;
  --menu-li-padding-y: 1.5%;
  --menu-li-padding-left: 8%;
  --menu-li-margin-y: 1%;
  --menu-logo-width: 83%;
  position: relative;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.logo {
  height: 30%;
}

.navigation {
  height: 100%;
  padding-bottom: 5%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
}

.bot-nav {
  margin: auto auto 5%;
  width: 100%;
}
.top-nav {
  width: 100%;
}

.logo img {
  width: var(--menu-logo-width);
  margin: 1vw auto auto;
  filter: drop-shadow(3px 3px 3px rgba(0, 0, 0, 0.3));
}

ul {
  display: flex;
  flex-direction: column;
  align-items: center;
  a.login {
    font-size: 120%;
  }
}

.cart-number {
  background: #fef35a;
  position: absolute;
  border-radius: 20rem;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 0.55em;
  box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.35);
  top: -0.3em;
  left: 1.15em;
  padding: 0.2em 0.5em 0.1em;
}

.navigation > div.bot-nav > ul > a:nth-child(4) {
  margin-top: 0.4em;
}

.navigation li {
  padding: var(--menu-li-padding-y) 2.5% var(--menu-li-padding-y)
    var(--menu-li-padding-left);
  margin: var(--menu-li-margin-y) auto;
  display: flex;
  align-items: center;
  gap: 6%;
  position: relative;
  font-size: var(--menu-li-size);
  font-style: normal;
  font-weight: 700;
  letter-spacing: 0.03em;
  width: var(--menu-li-width);

  &:hover {
    background: lighten($lt-gr-clr, 20%);
    transition-duration: 0.2s;
    border-radius: 0.625em;

    img {
      filter: brightness(0);
    }
  }

  img {
    width: 5em;
  }
  a {
    color: #000;
  }

  & > a {
    display: flex;
    gap: 6%;
    justify-content: flex-start;
    align-items: center;
  }
}

.icon {
  width: 10%;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    height: 100%;
    width: var(--menu-icon-size);
  }
}

.login {
  padding: 0.4em 0.8em;
  img {
    width: var(--menu-login-icon-size);
  }
}

.prihlaseny {
  padding: 0.4em 1.5em;
}

.login.no-padding {
  img {
    width: var(--menu-icon-size);
    padding: 0.6em 0 0.6em 0.8em;
  }
  p {
    padding: 0.6em 0.4em 0.6em 0;
  }
}

li:has(.router-link-active.router-link-exact-active) {
  background: $lt-gr-clr;
  border-radius: 0.625em;
  img {
    filter: brightness(0);
  }
}

section {
  padding: 0;
}

.moj-ucet .login .logout {
  height: 100%;
  fill: #fef35a;
  background: url("@/assets/images/icons/elipsaOdhlasenie.svg");
  padding-right: 0.6em;
  background-position: center;
  background-size: cover;
  margin-bottom: 0 !important;
  transition-duration: 0.2s;
}
.moj-ucet .login .logout:hover {
  transform: scale(1.1);
}
.moj-ucet .login .logout img {
  width: 0.95em;
  margin-right: 0;
}
.moj-ucet p {
  font-size: 0.8em;
}

@media only screen and (max-width: 1500px) {
  .moj-ucet {
    font-size: 90%;
  }
}

@media only screen and (max-height: 860px) {
  .menu {
    --menu-icon-size: 0.94em;
    --menu-login-icon-size: 1.32em;
    --menu-li-size: 1.46em;
    --menu-li-width: 12.8rem;
    --menu-logo-width: 77%;
  }
}

@media only screen and (max-height: 760px) {
  .menu {
    --menu-icon-size: 0.86em;
    --menu-login-icon-size: 1.2em;
    --menu-li-size: 1.3em;
    --menu-li-width: 11.8rem;
    --menu-li-padding-y: 1.2%;
    --menu-li-padding-left: 7.5%;
    --menu-li-margin-y: 0.7%;
    --menu-logo-width: 70%;
  }

  .login {
    padding: 0.34em 0.72em;
  }

  .prihlaseny {
    padding: 0.34em 1.2em;
  }
}

@media only screen and (max-height: 700px) {
  .menu {
    --menu-icon-size: 0.8em;
    --menu-login-icon-size: 1.1em;
    --menu-li-size: 1.2em;
    --menu-li-width: 11rem;
    --menu-li-padding-y: 1%;
    --menu-li-padding-left: 7.2%;
    --menu-li-margin-y: 0.45%;
    --menu-logo-width: 64%;
  }
}

@media only screen and (max-height: 620px) {
  .navigation {
    overflow-y: auto;
    overflow-x: hidden;
    scrollbar-width: thin;
  }

  .navigation::-webkit-scrollbar {
    width: 0.32em;
  }

  .navigation::-webkit-scrollbar-thumb {
    background: rgba(126, 171, 76, 0.55);
    border-radius: 1em;
  }
}

/* ——— vizuál „Nové“ prilepený k žltému buttonu ——— */
.menu-link-with-badge {
  position: relative; /* referenčný box pre badge */
}
.ha-new-badge {
  font-family: "Bahnschrift", sans-serif;
  position: absolute;
  top: -1em;
  right: -0.1em;
  padding: 0.18em 0.65em 0.12em;
  border-radius: 1em;
  background: #ff9900; /* oranžové pozadie */
  color: #ffffff; /* biely text */
  font-weight: 700;
  font-size: 0.9em;
  letter-spacing: 0.02em;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.25);
  outline: 2px solid rgba(255, 255, 255, 0.6);
  outline-offset: -2px;
}
</style>
